<template lang="pug">
v-container(fill-height)
  v-layout(justify-center align-center)
    v-card.elevation-25.notFound.pa-4.text-center
      v-img(src="@/assets/img/404_error.png" max-width="640")
      v-card-text.text-center 
        h2 {{$t('404.title')}}
      v-btn.mt-6(depressed color="accent" @click="$router.go(-1)") {{$t('general.back')}}
    
</template>
<script>
export default {};
</script>

<style lang="sass" scoped></style>
